import * as React from 'react';
import { TicketSelectionEvalState } from 'eTip--common';
import { translationForMts, numberFormatter } from 'easit--localization';

export interface ITicketDetailForVGSelectionsProps {
    selections: ITicketDetailForVGSelection[];
}

export interface ITicketDetailForVGSelection {
    id: number;
    betType: string;
    gameType: string;
    rate: number;
    fixtureName: string;
    result: string;
    evalState: TicketSelectionEvalState;
    tipName: string;
}

const getStateIcon = (state: TicketSelectionEvalState): React.ReactNode => {
    switch (state) {
        case TicketSelectionEvalState.Cancel: return <span className="state-icon fa fa-minus"></span>;
        case TicketSelectionEvalState.Cashout: return <span className="state-icon fa fa-thumbs-up"></span>;
        case TicketSelectionEvalState.None: return <span className="state-icon fa fa-question"></span>;
        case TicketSelectionEvalState.Loss: return <span className="state-icon fa fa-times"></span>;
        case TicketSelectionEvalState.Storno: return <span className="state-icon fa fa-ban"></span>;
        case TicketSelectionEvalState.Win: return <span className="state-icon fa fa-check"></span>;
        default: return <span className="state-icon fa fa-question"></span>;
    }
}

export const TicketDetailForVGSelections = (props: ITicketDetailForVGSelectionsProps) => {
    const t = translationForMts();
    return props.selections && props.selections.length
        ? <table className="w-100 tip-list selections">
            <thead>
                <tr>
                    <th>{t.bet_Match}</th>
                    <th>{t.rate}</th>
                    <th className="result-col"></th>
                </tr>
            </thead>
            <tbody>
                {
                    props.selections.map((selection, idx) => <React.Fragment key={selection.id}>
                        <tr className={`${idx % 2 === 0 ? 'odd' : 'even'}`}>
                            {/* <td className="text-center align-middle">{selection.number}</td> */}
                            <td className="p-2">

                                <span className="event-name pl-0">{selection.fixtureName}</span>
                                <br />
                                <span className="market-name">{selection.betType}</span>
                                <br />
                                <b>{selection.tipName}</b>
                                {((selection.result !== null)) &&
                                    <>
                                        <br />
                                        <span className="result">
                                            {<span className="mr-1">{t.ticket_SelectionResult}</span>}
                                            {selection.result}
                                        </span>
                                    </>}
                            </td>
                            <td className="text-center align-middle">{numberFormatter.format(selection.rate)}</td>
                            <td className="text-center align-middle icon-col">{getStateIcon(selection.evalState)}</td>

                        </tr>
                        <tr className="delimiter-row">
                            <td colSpan={5}>
                            </td>
                        </tr>
                    </React.Fragment>
                    )
                }
            </tbody>
        </table>
        : null
}